/**
 * 模块名称: 资金管理
 * @author zhuyan@372163.com
 */

 import React from 'react'
 import { Switch, Route } from 'react-router-dom'
 import Compare from './Compare'
 import Operational from './​Operational'

 
 const Funds = ({ match, history }) => {
   return (
     <Switch>
       <Route path={match.path + '/compare'} component={Compare} />
       <Route path={match.path + '/expendOperational'} component={Operational} />
       {/* <Route component={Compare} /> */}
     </Switch>
   )
 }
 
 export default Funds